import React, { useState, useEffect } from "react";
import Loader from "react-loader-spinner";
import { useDispatch } from "react-redux";
import moment from "moment";
import { Modal, Col, Form, Row, Button } from "react-bootstrap";
import {
  FormControl,
  Select,
  InputLabel,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import {
  NewInputText,
  NewSelectBoxInput,
} from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import Alert from "react-s-alert";

import { useFormik } from "formik";
import * as yup from "yup";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getCountries } from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  getCityFromCountry,
  getRestaurantByCityName,
} from "../../../../store/actions/SuperAdminActions/adminManageOffers";
import { getSubCateogryWithCategoryId } from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import {
  admin_add_merchant_promotion,
  admin_get_requested_merchant_promotion,
} from "../../../../store/actions/SuperAdminActions/superAdminMerchantPromotion";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const validate = (values) => {
  const errors = {};

  if (values.restaurantName === "" && values.restaurant_id === "") {
    errors.restaurant_id = "Merchant Info is required";
  }

  return errors;
};

const SuperAdminAddMerchantRequest = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const token = props.auth.user.accessToken;
  const [dateQuery, setDateQuery] = useState({
    startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });

  const [show, setShow] = useState(false);
  const onOpen = (e) => {
    formik.resetForm();
    setShow(true);
  };
  const onClose = (e) => {
    formik.resetForm();
    setState({
      ...state,
      country: "",
      city: "",
      restaurantName: "",
      restaurant_id: "",
      // vendor_id: "",
    });
    setShow(false);
  };

  useEffect(() => {
    const promotionType = "62114b735ccac51d80d70810";
    const restaurantTags = "62114cff5ccac51d80d70b43";
    /********** @DESC GET PROMOTION TYPE **********/
    dispatch(
      getSubCateogryWithCategoryId(onSuccessGetPromotionType, promotionType)
    );
    /********** @DESC GET RESTAURANT TAGS **********/
    dispatch(
      getSubCateogryWithCategoryId(onSuccessGetRestaurantTags, restaurantTags)
    );
  }, []);

  const [loading, setLoading] = useState(false);
  const [promotionType, getPromotionType] = useState([]);
  const [restaurantTags, getRestaurantTags] = useState([]);

  /******************************
   * @DESC GET PROMOTION TYPE
   ******************************/
  const onSuccessGetPromotionType = (data) => {
    var subC = [];
    for (var i = 0; i < data.length; i++) {
      subC.push({
        icon_code: data[i].icon_code,
        name: data[i].title,
        id: data[i]._id,
        status: data[i].status,
        icon: data[i].icon,
        description: data[i].description,
      });
    }
    getPromotionType(subC);
    setLoading(false);
  };

  /******************************
   * @DESC GET RESTAURANT TAGS
   ******************************/
  const onSuccessGetRestaurantTags = (data) => {
    var subC = [];
    for (var i = 0; i < data.length; i++) {
      subC.push({
        icon_code: data[i].icon_code,
        name: data[i].title,
        id: data[i]._id,
        status: data[i].status,
        icon: data[i].icon,
        description: data[i].description,
      });
    }
    getRestaurantTags(subC);
    setLoading(false);
  };

  const [city, setCity] = useState([]);
  const [restaurant, setRestaurant] = useState([]);
  const [state, setState] = useState({
    country: "",
    city: "",
    restaurantName: "",
    restaurant_id: "",
    vendor_id: "",
  });

  /************************************
   * @DESC GET COUNTRY NAME
   ***********************************/
  const selecthandleChange = (e) => {
    props.getCityFromCountry(
      e.target.value,
      token,
      onSuccessGetCity,
      onErrorGetCity
    );
    setState({ [e.target.name]: e.target.value });
    formik.setFieldValue("country", e.target.value);
    formik.setFieldValue("city", "");
    formik.setFieldValue("restaurantName", "");
    formik.setFieldValue("restaurant_id", "");
    // formik.setFieldValue("vendor_ID", "");
    setRestaurant([]);
    setCity([]);
  };

  /************************************
   * @DESC GET CITY NAME
   ***********************************/
  const onSuccessGetCity = (data) => {
    var prepareCity = [];
    for (var i = 0; i < data.length; i++) {
      if (/^[a-zA-Z]+$/.test(data[i]))
        prepareCity.push({ label: data[i], value: data[i] });
    }
    prepareCity = prepareCity.sort((a, b) => a?.label - b?.label);
    setCity(prepareCity);
  };
  const onErrorGetCity = () => {};

  /************************************
   * @DESC GET RESTAURANT INFO
   ***********************************/
  const loadRestaurant = (event) => {
    setState({
      ...state,
      city: event.target.value,
    });
    formik.setFieldValue("country", state.country);
    formik.setFieldValue("city", event.target.value);
    formik.setFieldValue("restaurantName", "");
    formik.setFieldValue("restaurant_id", "");
    // formik.setFieldValue("vendor_ID", "");
    props.getRestaurantByCityName(
      state.country,
      event.target.value,
      token,
      onSuccessGetRestaurant,
      onErrorGetRestaurant
    );
  };

  const onSuccessGetRestaurant = (data) => {
    // formik.setFieldValue("vendor_ID", "");
    var prepareRestaurant = [];
    for (var i = 0; i < data.length; i++) {
      prepareRestaurant.push(data[i]);
    }
    setRestaurant(prepareRestaurant);
  };
  const onErrorGetRestaurant = () => {};

  /************************************
   * @DESC SET RESTAURANT INFO
   ***********************************/
  const onChangeRestaurant = (event) => {
    // formik.setFieldValue("vendor_ID", "");
    setState({
      ...state,
      restaurantName: event.target.value,
    });
    for (var i = 0; i < restaurant.length; i++) {
      if (restaurant[i]._id === event.target.value) {
        formik.setFieldValue("restaurant_id", restaurant[i]._id);
        formik.setFieldValue("restaurantName", restaurant[i].restaurant_name);
        // formik.setFieldValue("vendor_id", restaurant[i].vendor_id);
        // formik.setFieldValue("location", restaurant[i].location);
      }
    }
  };

  /************************************
   * @DESC ON CHANGE RESTAURANT INPUT
   ***********************************/
  const vendorIdChangeHandler = (e) => {
    setState({
      ...state,
      country: "",
      city: "",
      restaurantName: "",
      restaurant_id: "",
    });
    formik.setFieldValue("restaurant_id", e.target.value);
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const formik = useFormik({
    initialValues: {
      country: "",
      city: "",
      restaurantName: "",
      restaurant_id: "",
      promotionType: "",
      requestTag: "",
    },
    validationSchema: yup.object({
      promotionType: yup.string().required("Promotion type is required"),
      requestTag: yup.string().required("Request tag is required"),
    }),
    validate,
    onSubmit: (values) => {
      let formData = {
        restaurant_id: values.restaurant_id,
        permotion_type: values.promotionType,
        tag: values.requestTag,
      };
      dispatch(
        admin_add_merchant_promotion(token, formData, onSuccessAddPromotion)
      );
    },
  });

  const onSuccessAddPromotion = () => {
    Alert.success(`<h4>Merchant promotion request added successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 5000,
      offset: 35,
    });
    dispatch(
      admin_get_requested_merchant_promotion(
        token,
        1,
        10,
        false,
        dateQuery,
        () => onSuccessPagination(),
        true,
        0,
        false,
        false,
        false
      )
    );
  };

  const onSuccessPagination = () => {
    formik.resetForm();
    onClose();
  };

  const [count, setCount] = useState(1);
  const onClickSave = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  useEffect(() => {
    if (formik.errors && formik.errors.restaurant_id) {
      let restaurant_idElement = document.getElementById("restaurant_id");
      restaurant_idElement.focus();
    } else if (formik.errors && formik.errors.promotionType) {
      let promotionTypeElement = document.getElementById("promotionType");
      promotionTypeElement.focus();
    } else if (formik.errors && formik.errors.requestTag) {
      let requestTagtElement = document.getElementById("requestTag");
      requestTagtElement.focus();
    }
  }, [count]);

  return (
    <React.Fragment>
      <div
        onClick={onOpen}
        className="px-4 py-2 btn f12-500 new-addcreate-button"
      >
        Create Request
      </div>
      <Modal show={show} onHide={onClose} centered>
        <Modal.Header className="py-4 border-0" closeButton>
          <Modal.Title>
            <h3 className="f20_700_HelveticaNeue">Create Request</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500 pt-0">
          <Form noValidate onSubmit={(e) => onClickSave(e)}>
            <Row>
              <Col xs={6} sm={6} md={6}>
                <NewSelectBoxInput
                  selectLabel="Country"
                  name="country"
                  value={state.country}
                  onChange={selecthandleChange}
                  getCountries={getCountries}
                  en={en}
                />
              </Col>
              <Col xs={6} sm={6} md={6}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel id="demo-simple-select-outlined-label">
                    City
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={state.city}
                    defaultValue={state.city}
                    onChange={loadRestaurant}
                    label="City"
                    name="city"
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <MenuItem value="" disabled selected>
                      Select City
                    </MenuItem>
                    {city &&
                      city.map((country) => (
                        <MenuItem key={country.value} value={country.value}>
                          {country.value}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Col>
              <Col xs={12} className="mt-4">
                <FormControl variant="outlined" fullWidth>
                  <InputLabel id="demo-simple-select-outlined-label">
                    Select Restaurant
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={state.restaurantName}
                    defaultValue={state.restaurantName}
                    onChange={onChangeRestaurant}
                    label="Select Restaurant"
                    name="restaurantName"
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <MenuItem value="" disabled selected>
                      Select Select Restaurant
                    </MenuItem>
                    {restaurant &&
                      restaurant.map(
                        (item) =>
                          item.restaurant_name !== null &&
                          item.restaurant_name !== undefined && (
                            <MenuItem key={item._id} value={`${item._id}`}>
                              {`${item.restaurant_name}`}
                            </MenuItem>
                          )
                      )}
                  </Select>
                </FormControl>
                {state.restaurantName === "" ? (
                  formik.errors.restaurant_id &&
                  formik.touched.restaurant_id ? (
                    <div className="f10-500 text-danger mt-1">
                      {formik.errors.restaurant_id}
                    </div>
                  ) : null
                ) : null}
              </Col>
              <Col xs={12}>
                <h3 className="f20-700 my-3 col-12 p-0">OR</h3>
                <hr className="mb-4" />
              </Col>
              <Col xs={12} className="mb-4">
                <NewInputText
                  extraClass="mb-1"
                  name="restaurant_id"
                  maxLength={35}
                  onInput={maxLengthCheck}
                  inputType="text"
                  onFocusOut={formik.handleBlur}
                  onChange={(e) => vendorIdChangeHandler(e)}
                  value={formik.values.restaurant_id}
                  labelText="Merchant ID"
                  controlClass="restaurant_id"
                />
                {formik.errors.restaurant_id && formik.touched.restaurant_id ? (
                  <div className="f10-500 text-danger mt-1">
                    {formik.errors.restaurant_id}
                  </div>
                ) : null}
              </Col>
              <Col xs={12} className="mb-4">
                <FormControl fullWidth variant="outlined">
                  <InputLabel id="demo-simple-select-label">
                    Promotion Type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="promotionType"
                    name="promotionType"
                    label="Promotion Type"
                    className={`w-100 ${
                      formik.errors.promotionType &&
                      formik.touched.promotionType
                        ? "enError"
                        : ""
                    }`}
                    onChange={formik.handleChange}
                    value={formik.values.promotionType}
                    onBlur={formik.handleBlur}
                  >
                    <MenuItem value="" disabled selected>
                      Select Promotion Type
                    </MenuItem>
                    {promotionType &&
                      promotionType?.map((data, index) => {
                        return (
                          <MenuItem
                            key={index}
                            value={data.name}
                            name={data.name}
                          >
                            {data.name}
                          </MenuItem>
                        );
                      })}
                  </Select>
                  {formik.errors.promotionType &&
                  formik.touched.promotionType ? (
                    <div className="f10-500 text-danger mt-1">
                      {formik.errors.promotionType}
                    </div>
                  ) : null}
                </FormControl>
              </Col>
              <Col xs={12}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel id="demo-simple-select-label">
                    Requested Tag
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="requestTag"
                    name="requestTag"
                    label="Requested Tag"
                    className={`w-100 ${
                      formik.errors.requestTag && formik.touched.requestTag
                        ? "enError"
                        : ""
                    }`}
                    onChange={formik.handleChange}
                    value={formik.values.requestTag}
                    onBlur={formik.handleBlur}
                  >
                    <MenuItem value="" disabled selected>
                      Select Requested Tag
                    </MenuItem>
                    {restaurantTags &&
                      restaurantTags?.map((data, index) => {
                        return (
                          <MenuItem
                            key={index}
                            value={data.name}
                            name={data.name}
                          >
                            {data.name}
                          </MenuItem>
                        );
                      })}
                  </Select>
                  {formik.errors.requestTag && formik.touched.requestTag ? (
                    <div className="f10-500 text-danger mt-1">
                      {formik.errors.requestTag}
                    </div>
                  ) : null}
                </FormControl>
              </Col>
            </Row>
            <Row className="align-items-center mt-4 mb-2">
              <Col xs={4} sm={4} md={3}>
                <Button
                  variant="outline-secondary"
                  className="px-4 f18-500"
                  style={{
                    borderRadius: 8,
                    paddingTop: 8,
                    paddingBottom: 8,
                  }}
                  title="Cancel"
                  onClick={onClose}
                >
                  Cancel
                </Button>
              </Col>
              <Col xs={4} sm={4} md={3}>
                <Button
                  variant="danger"
                  className="px-4 f18-500"
                  style={{
                    borderRadius: 8,
                    backgroundColor: "#EE3A23",
                    paddingTop: 8,
                    paddingBottom: 8,
                  }}
                  type="Submit"
                  //   title={
                  //     editUom?.editAction
                  //       ? "Update Uom Ratio"
                  //       : "Add Uom Ratio"
                  //   }
                  title={"Create Promotion"}
                >
                  {/* {editUom?.editAction ? "Update" : "Add"} */}
                  Create
                </Button>
              </Col>
              <Col xs={2}>
                {props.auth?.secondary_loader ? (
                  <Loader type="Puff" color="#00BFFF" height={30} width={30} />
                ) : null}
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

SuperAdminAddMerchantRequest.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  clear_all_errors: PropTypes.func.isRequired,
  getCityFromCountry: PropTypes.func.isRequired,
  getRestaurantByCityName: PropTypes.func.isRequired,
  getSubCateogryWithCategoryId: PropTypes.func.isRequired,
  admin_add_merchant_promotion: PropTypes.func.isRequired,
  admin_get_requested_merchant_promotion: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  getCityFromCountry,
  getRestaurantByCityName,
  getSubCateogryWithCategoryId,
  admin_add_merchant_promotion,
  admin_get_requested_merchant_promotion,
})(withRouter(SuperAdminAddMerchantRequest));
